import http from '../helpers/http';

export default class SwipeRepository {

    async uploadSwipe(swipe) {

        const swipeData = {
            serialNumber: swipe.serialNumber,
            cardCheckSerialNumber: swipe.cardCheckSerialNumber,
            readerID: swipe.readerID,
            sponsorID: swipe.sponsorID,
            swipeEvent: swipe.swipeEvent,
            utcSwipeDate: swipe.utcSwipeDate,
            offline: swipe.offline,
            denyReasonID: swipe.denyReasonID,
            swipeType: swipe.swipeType,
            divisionID: swipe.divisionID,
            projectID: swipe.projectID,
            siteCode: swipe.siteCode,
            zoneCode: swipe.zoneCode,
            competenceID: swipe.competenceID,
            jobRoleID: swipe.jobRoleID,
            employerID: swipe.employerID,
            competenceExpiryDate: swipe.competenceExpiryDate,
            certificate: swipe.certificate,
            travelTimeFromPlaceOfRestHours: swipe.travelTimeFromPlaceOfRestHours,
            travelTimeFromPlaceOfRestMinutes: swipe.travelTimeFromPlaceOfRestMinutes,
            travelTimeToPlaceOfRestHours: swipe.travelTimeToPlaceOfRestHours,
            travelTimeToPlaceOfRestMinutes: swipe.travelTimeToPlaceOfRestMinutes,
            associationID: swipe.associationID,
            visitorPassID: swipe.visitorPass ? swipe.visitorPass.visitorPassID : null,
            swipeOutcome: swipe.swipeOutcome,
        };

        const response = await http.post('/api/v1/swipes', swipeData);

        // Transform the rather non standard response status / error indicator into the expected
        // format. If the response is successful, return the swipe data so it can be used in the
        // reducer to store the swipe locally
        if (response.result === true) {
            return {
                success: true,
                swipe: swipe
            };
        }
        else {
            return {
                success: false,
                message: response.errorInfo
            };
        }
    }
}